export default "key,en,es-ES,es-LA,ca,zh-CN,zh-TW,ja,it,de,fr,pt-PT,ru,pt-BR,pl,tr,eu,oc,th,ko,cs\n"